module.exports = __webpack_public_path__ + "img/b5.92123099.jpg";